import { render } from "./ContactView.vue?vue&type=template&id=5622f30d"
import script from "./ContactView.vue?vue&type=script&lang=js"
export * from "./ContactView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__